import { SOGetOrganization } from '../organization/so-get-organization';


export class SOPostProject {

  constructor(
    public name: string,
    public organization: SOGetOrganization,
    public description: string = "",
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostProject(
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'organization' in params ? params.organization : null,
    );
  }
}
